import React from 'react';
import { FaStar } from 'react-icons/fa';

export default function Star({ selected = false, onSelect = (f) => f }) {
  return <FaStar color={selected ? 'yellow' : 'lightgray'} onClick={onSelect} size={20} />;
}
